import React, { useEffect, useRef, useState } from 'react';

export const G = '#34c800';

export const Reveal = ({ children, delay = 0, className = '' }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setInView(true);
          obs.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return (
    <div ref={ref} className={`cb-reveal ${inView ? 'cb-in' : ''} ${className}`} style={{ animationDelay: `${delay}ms` }}>
      {children}
    </div>
  );
};

export const SectionLabel = ({ children }) => (
  <div className="flex items-center gap-2.5 mb-4">
    <span className="w-6 h-px" style={{ background: G }} />
    <p className="font-display font-bold text-xs sm:text-sm uppercase tracking-[0.22em]" style={{ color: G }}>
      {children}
    </p>
  </div>
);

export const Heading = ({ children, className = '' }) => (
  <h2 className={`font-display font-extrabold text-white leading-[1.02] tracking-tight text-3xl sm:text-4xl lg:text-5xl ${className}`}>
    {children}
  </h2>
);

export const ScrollProgress = () => {
  const [w, setW] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setW(max > 0 ? (h.scrollTop / max) * 100 : 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className="fixed top-0 left-0 h-[3px] z-[60] transition-[width] duration-75" style={{ width: `${w}%`, background: G }} />;
};
